import { render } from "./g-logo.vue?vue&type=template&id=629cd314&ts=true"
import script from "./g-logo.vue?vue&type=script&lang=tsx"
export * from "./g-logo.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__